import React from "react";

const InquiringIcon = ({active}) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.84748 6.70312C4.56156 6.70312 4.33008 6.94141 4.33008 7.22734C4.33008 7.50646 4.55475 7.75156 4.84748 7.75156C5.14021 7.75156 5.3717 7.50648 5.3717 7.22734C5.3717 6.94141 5.13344 6.70312 4.84748 6.70312Z"
        fill={active? "white": "black"}
      />
      <path
        d="M4.93492 2.73438C4.01584 2.73438 3.59375 3.279 3.59375 3.64664C3.59375 3.91217 3.8184 4.03471 4.00223 4.03471C4.36984 4.03471 4.22008 3.51049 4.91449 3.51049C5.2549 3.51049 5.52723 3.66027 5.52723 3.97344C5.52723 4.34109 5.14598 4.55213 4.92131 4.74275C4.72389 4.91295 4.46518 5.19209 4.46518 5.77758C4.46518 6.13158 4.56047 6.23371 4.83961 6.23371C5.1732 6.23371 5.24127 6.08395 5.24127 5.95459C5.24127 5.60057 5.24811 5.39633 5.62254 5.10359C5.80635 4.96062 6.38504 4.49768 6.38504 3.85771C6.38504 3.21775 5.80635 2.73438 4.93492 2.73438Z"
        fill={active? "white": "black"}
      />
      <path
        d="M5 0C2.23664 0 0 2.23627 0 5V9.60938C0 9.82512 0.174883 10 0.390625 10H5C7.76334 10 10 7.76373 10 5C10 2.23664 7.76373 0 5 0ZM5 9.21875H0.78125V5C0.78125 2.66842 2.66811 0.78125 5 0.78125C7.33158 0.78125 9.21875 2.66811 9.21875 5C9.21875 7.33158 7.33189 9.21875 5 9.21875Z"
        fill={active? "white": "black"}
      />
    </svg>
  );
};

export default InquiringIcon;
